import styled from 'styled-components'

export const HeaderContent = styled.div`
	max-width: 1600px;
	width: 100%;
`
